import { Injectable, Injector } from '@angular/core';
import { MonthlyRecap } from '../../models/monthly-recap.model';
import { InvestmentRecap } from '../../models/investment-recap.model';
import { Investment } from '../../models/investment.model';
const proplist: string[]=['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dic','tot'];

@Injectable()
export class FinancialUtilityService {

  public static getTotal(list: MonthlyRecap[]): MonthlyRecap {
    // 1. Inizializziamo l'oggetto con i campi a 0 (adattalo ai tuoi campi reali)
    const total: MonthlyRecap = {
      etiquetteId: 0,
      shortDescription: "TOTALE",
      accountingYear: 0,
      finWalletId: 0,
      finTradeTypeId: 0,
      // Mesi inizializzati a 0 per permettere la somma +=
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      oct: 0,
      nov: 0,
      dic: 0,
      tot: 0,
      monthClicked: 0,
      isBoldRow: true // Impostato a true se questo è l'oggetto dei totali
  };

    if (!list || list.length === 0) return total;

    // 2. Definiamo le chiavi su cui iterare (se non vuoi usare una variabile esterna)
    const keys = Object.keys(list[0]) as Array<keyof MonthlyRecap>;

    list.forEach((elemento) => {
        keys.forEach((prop) => {
            const valore = elemento[prop];
            // 3. Sommiamo solo se il valore è un numero
            if (typeof valore === 'number') {
                (total[prop] as number) += valore;
            }
        });
    });

    return total;
}


  public static getPercInv(investmentRecap: InvestmentRecap): number{
    return ((Math.abs(investmentRecap.totalSelledValue) + investmentRecap.totalActualValue) / (investmentRecap.totalPurchaseValue)) -1;
  }

  public static getPercInvTax(investmentRecap: InvestmentRecap): number{
    return ((investmentRecap.totalActualValue ) / (investmentRecap.totalPurchaseValue + investmentRecap.sellCommissionCost + investmentRecap.buyCommissionCost ))-1;
  }

  
  public static getPercTotal(investmentRecap: InvestmentRecap): number{
    return ((Math.abs(investmentRecap.totalSelledValue) + investmentRecap.totalDividendValue + investmentRecap.totalActualValue) / investmentRecap.totalPurchaseValue) -1;
  }

  public static getPercTotalTax(investmentRecap: InvestmentRecap): number{
    return ((Math.abs(investmentRecap.totalSelledValue) + investmentRecap.totalDividendValue + investmentRecap.totalActualValue) / (investmentRecap.totalPurchaseValue + investmentRecap.totalCommissionCost))-1;
  }

  
  public static calculateTAN(investmentRecap: InvestmentRecap) {
    // ... (calcoli preliminari per ottenere i rendimenti individuali di ogni transazione)
  
    let valoreTotaleIniziale = 0;
    let valoreTotaleFinale = 0;
    let periodoTotale = 0;
  
    investmentRecap.tradeList.forEach((trade: Investment) => {
      // Calcola il periodo di detenzione in giorni (semplificando, senza considerare gli anni bisestili)
      const periodoDetenzione = Math.abs(new Date().getTime() - new Date(trade.accountingDate).getTime()) / (1000 * 60 * 60 * 24);

      let quantityNotZ= (trade.quantity!=0 ?trade.quantity : 1);
      // Calcola il valore iniziale e finale della transazione
      const valoreIniziale = quantityNotZ * trade.purchaseValue;
      const valoreFinale = quantityNotZ * investmentRecap.priceValue; // o valore attuale se non venduto
  
      valoreTotaleIniziale += valoreIniziale;
      valoreTotaleFinale += valoreFinale;
      periodoTotale += periodoDetenzione;

    });
  

    // Calcola il rendimento medio ponderato nel tempo
    let rendimentoMedioPonderato = (valoreTotaleFinale / valoreTotaleIniziale - 1) / (periodoTotale / 365); // Rendimento annualizzato
    
    return rendimentoMedioPonderato;
  }

  
  
  public static backgroudColorList: string[]=[
    "#36A2EB",
    '#1ab394',    "#FFCE56",

    '#00b7f4',
    '#00bcd4',
    '#fff0f5',
    '#b2e6ff',
    '#c5f0f1',
    '#f0fff0',
    '#ffe6f0',
    '#e6f0ff',
    '#ffe6f0',
    '#ffffe0',
    '#f5f5f5',
    '#f0f0f0',
    '#99ffff',
    '#d9f0ff',
    '#fffae6',
    '#ffe4e1',
    '#f0e6e6',
    '#e0ffff',
    '#e6f5ff'];
}